import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import DiceUtil from '../utils/DiceUtil';
import TreasureRenderer from './TreasureRenderer';
import IndividualTreasure from './IndividualTreasure.json';
import TreasureHoard from './TreasureHoard.json';
import withRoot from '../withRoot';

const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
});

class TreasureGenerator extends Component {
  state = {
    crRange: 0,
    resultCount: 1,
    treasureResults: null,
  };

  setCrRange(event) {
    const value = event.target.value;
    this.setState({ crRange: value });
  }

  setResultCount(event) {
    const value = event.target.value;
    this.setState({ resultCount: value });
  }

  getCoinTreasure(element) {
    const multiplier = element.multiplier ? element.multiplier : 1;
    const value = DiceUtil.diceLoop(element.faces, element.count) * multiplier;
    return value + " " + element.type;
  }

  getTreasureFromCoins(coins) {
    let treasure = Array(coins.length);
    for (let i = 0; i < coins.length; i++) {
      treasure[i] = this.getCoinTreasure(coins[i]);
    }
    return treasure;
  }

  getTreasureRow(table) {
    let treasureRow = null;
    const d100Roll = DiceUtil.d100(1);
    for (let i = 0; i < table.length; i++) {
      treasureRow = table[i];
      if (d100Roll <= treasureRow.d100Max) {
        break;
      }
    }
    return treasureRow;
  }

  generateIndividualTreasure() {
    const selectedCrRange = IndividualTreasure.tables[this.state.crRange];
    const resultCount = this.state.resultCount;

    const results = Array(resultCount);

    for (let i = 0; i < resultCount; i++) {
      let treasure = {};
      let row = this.getTreasureRow(selectedCrRange.table);
      treasure.coins = this.getTreasureFromCoins(row.coins);
      results[i] = treasure;
    }

    this.setState({ treasureResults: results });
  }

  addTreasureToArray(array, item, quantity) {
    for (let i = 0; i < array.length; i++) {
      let current = array[i];
      if (current.item === item) {
        current.quantity += quantity;
        return;
      }
    }

    array[array.length] = { quantity: quantity, item: item };
  }

  getTreasureFromValuables(table) {
    const row = this.getTreasureRow(table);
    if (!row.type) return null;

    const valuables = TreasureHoard[row.type][row.value];
    const count = DiceUtil.diceLoop(row.faces, row.count);

    const treasures = [];
    for (let i = 0; i < count; i++) {
      this.addTreasureToArray(treasures, valuables[DiceUtil.dice(valuables.length) - 1] + " (" + row.value + " gp)", 1);
    }
    return treasures;
  }

  getTreasureFromItems(table) {
    const row = this.getTreasureRow(table);
    if (!row.tables) return null;

    const treasures = [];

    for (let i = 0; i < row.tables.length; i++) {
      let tableData = row.tables[i];
      let itemTable = TreasureHoard.items[tableData.table];
      let count = DiceUtil.diceLoop(tableData.faces, tableData.count);

      for (let j = 0; j < count; j++) {
        let itemRow = this.getTreasureRow(itemTable);
        if (itemRow) {
          if (itemRow.subItems) {
            this.addTreasureToArray(treasures, itemRow.subItems[DiceUtil.dice(itemRow.subItems.length) - 1], 1);
          } else {
            this.addTreasureToArray(treasures, itemRow.item, 1);
          }
        }
      }
    }

    return treasures;
  }

  generateTreasureHoard() {
    const selectedCrTable = TreasureHoard.treasure[this.state.crRange];
    const resultCount = this.state.resultCount;

    const results = Array(resultCount);

    for (let i = 0; i < resultCount; i++) {
      let treasure = {};
      treasure.coins = this.getTreasureFromCoins(selectedCrTable.coins);
      treasure.valuables = this.getTreasureFromValuables(selectedCrTable.valuables);
      treasure.items = this.getTreasureFromItems(selectedCrTable.items);
      results[i] = treasure;
    }

    this.setState({ treasureResults: results });
  }

  render() {
    const { classes } = this.props;
    const treasureTables = IndividualTreasure.tables;
    const chalengeRatings = Array(treasureTables.length);
    for (let i = 0; i < treasureTables.length; i++) {
      chalengeRatings[i] = treasureTables[i].crRange;
    }

    const resultCounts = [1, 4, 6, 8, 10, 12, 20].map((value) => {
      return (
        <MenuItem key={value} value={value}>{value}</MenuItem>
      );
    });

    const options = chalengeRatings.map((value, index) => {
      return (
        <MenuItem key={index} value={index}>{value}</MenuItem>
      );
    });

    return (
      <div>
        <div>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="results">Results</InputLabel>
            <Select value={this.state.resultCount} onChange={(event) => this.setResultCount(event)} inputProps={{ id: 'results' }}>{resultCounts}</Select>
          </FormControl>
          <FormControl className={classes.formControl}>
            <InputLabel htmlFor="cr">CR</InputLabel>
            <Select value={this.state.crRange} onChange={(event) => this.setCrRange(event)} inputProps={{ id: 'cr' }}>{options}</Select>
          </FormControl>
        </div>

        <div>
          <Button variant="raised" color="primary" className={classes.button} onClick={() => this.generateIndividualTreasure()}>Individual Treasure</Button>
          <Button variant="raised" color="secondary" className={classes.button} onClick={() => this.generateTreasureHoard()}>Treasure Hoard</Button>
        </div>

        <TreasureRenderer treasures={this.state.treasureResults} />
      </div>
    );
  }
}

TreasureGenerator.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRoot("Treasure Generator", withStyles(styles)(TreasureGenerator));


// WEBPACK FOOTER //
// ./src/treasure-generator/TreasureGenerator.js